// extracted by mini-css-extract-plugin
export default {"activeTab":"ExecutivesMatchesReview_activeTab__Bd0IV","count":"ExecutivesMatchesReview_count__30HFu"};